// extracted by mini-css-extract-plugin
export default {"lensID":"AvatarTableCell_lensID__J4-aL","role":"AvatarTableCell_role__1g1FG"};